"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EMPTY_NOTE = function () { return ({
    content: "",
    allowed_roles: {
        students: false,
        instructors: true,
        administrators: true,
        staff: true,
    },
}); };
var InstructorStudentNotesController = /** @class */ (function () {
    function InstructorStudentNotesController($stateParams, UserService, $sce, FlashService, student, VueStoreFactory, $q) {
        this.handleAddNoteChange = this.handleAddNoteChange.bind(this);
        this.studentNotesPageChanged = this.studentNotesPageChanged.bind(this);
        this.addNote = this.addNote.bind(this);
        this.getRole = this.getRole.bind(this);
        this.$stateParams = $stateParams;
        this.student = student;
        this.VueStoreFactory = VueStoreFactory;
        this.$q = $q;
        this.$sce = $sce;
        this.currentUser = UserService.getCurrentUser();
        this.FlashService = FlashService;
        this.submitting = false;
        this.note = EMPTY_NOTE();
        this.studentNotes = VueStoreFactory.state.studentNotes;
        this.notesPage = 1;
        this.loadNotes(1);
    }
    InstructorStudentNotesController.prototype.loadNotes = function (page) {
        var _this = this;
        this.submitting = true;
        return this.$q
            .when(this.VueStoreFactory.dispatch("studentNotes/GET_STUDENT_NOTES", {
            studentId: this.student.id,
            page: page,
        }))
            .then(function () {
            _this.notesPage = _this.studentNotes.currentPage;
        })
            .finally(function () {
            _this.submitting = false;
        });
    };
    InstructorStudentNotesController.prototype.formatNoteContent = function (note) {
        return this.$sce.trustAsHtml(note);
    };
    InstructorStudentNotesController.prototype.handleAddNoteChange = function (data) {
        this.note.content = data.html;
    };
    InstructorStudentNotesController.prototype.deleteNote = function (note) {
        var _this = this;
        this.submitting = true;
        this.$q
            .when(this.VueStoreFactory.dispatch("studentNotes/REMOVE_STUDENT_NOTE", {
            studentId: this.student.id,
            noteId: note.id,
        }))
            .then(function (response) {
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
            _this.notesPage = _this.studentNotes.currentPage;
        })
            .finally(function () {
            _this.submitting = false;
        });
    };
    InstructorStudentNotesController.prototype.getRole = function (role) {
        if (role === 1) {
            return "Students";
        }
        if (role === 3) {
            return "Instructors";
        }
        if (role === 4) {
            return "Owners";
        }
        if (role === 5) {
            return "Administrators";
        }
        if (role === 9) {
            return "Staff";
        }
        return "Owner";
    };
    InstructorStudentNotesController.prototype.addNote = function () {
        var _this = this;
        this.submitting = true;
        var note = this.note;
        // Clear the editor straight away rather than after the refetch round trip.
        this.note = EMPTY_NOTE();
        this.$q
            .when(this.VueStoreFactory.dispatch("studentNotes/ADD_STUDENT_NOTE", {
            studentId: this.student.id,
            note: note,
        }))
            .then(function (response) {
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
            _this.notesPage = _this.studentNotes.currentPage;
        })
            .catch(function () {
            // Give the instructor their note back so they don't lose what they typed.
            _this.note = note;
        })
            .finally(function () {
            _this.submitting = false;
        });
    };
    InstructorStudentNotesController.prototype.studentNotesPageChanged = function () {
        this.loadNotes(this.notesPage);
    };
    InstructorStudentNotesController.prototype.getStudentAge = function () {
        if (this.student === null) {
            return 100;
        }
        if (typeof this.student.usermeta === "undefined") {
            return 100;
        }
        if (typeof this.student.usermeta.dob === "undefined") {
            return 100;
        }
        var dob = new Date(this.student.usermeta.dob);
        var today = new Date();
        var ageInYears = today.getFullYear() - dob.getFullYear();
        var monthDiff = today.getMonth() - dob.getMonth();
        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
            return ageInYears - 1;
        }
        return ageInYears;
    };
    return InstructorStudentNotesController;
}());
InstructorStudentNotesController.$inject = [
    "$stateParams",
    "UserService",
    "$sce",
    "FlashService",
    "student",
    "VueStoreFactory",
    "$q",
];
exports.default = InstructorStudentNotesController;
